import React from 'react';
import { Helmet } from 'react-helmet';
import { Button, Col, Row } from 'reactstrap';
import Typewriter from 'typewriter-effect';

const PersonalInfo = () => {
  return (
    <Row
      style={{
        color: 'white',
      }}
      className=" mt-4 pt-4"
    >
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="Azim Uddin Ahamed"
          content="Azim Uddin Ahamed . Web Application Developer  "
        />
      </Helmet>
      <Col
        className="mb-5 mb-md-0 text-center"
        xs={{
          size: 12,
          order: 2,
        }}
        sm={{
          size: 12,
          order: 2,
        }}
        lg={6}
        md={{
          size: 12,
          order: 1,
        }}
      >
        <div>
          <h1 className="py-1">Azim Uddin Ahamed</h1>
          <Typewriter
            options={{
              strings: ['Front-End Developer', 'MERN Stack Developer'],
              autoStart: true,
              loop: true,
            }}
          />
          <br />
        </div>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/azimuahamed/"
        >
          <Button className="mr-2 my-3" outline color="info">
            ---Hire me---
          </Button>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          // href="https://drive.google.com/u/1/uc?id=1WuszKFXySEJi6lGh8qqpXo9rmpPcRwRi&export=download"
          href="https://drive.google.com/u/0/uc?id=1ZHnVz2BarpsaEHGm3sQXfo6wibyqc-65&export=download"
          download
        >
          <Button className="ml-1" contained="true" color="danger">
            Download Resume
          </Button>
        </a>
      </Col>
      <Col
        className="text-center my-3 my-md-0"
        xs={{
          size: 12,
          order: 1,
        }}
        sm={{
          size: 12,
          order: 1,
        }}
        lg={6}
        md={{
          size: 12,
          order: 2,
        }}
      >
        <img
          className="img-fluid"
          title="A photo of Azim Ahmed"
          style={{
            width: '250px',
            height: '250px',
            borderBottom: '12px solid tomato',
            border: '10px solid #dc3545',
            borderRadius: '55%',
          }}
          src="https://i.ibb.co/52Xxn5W/profile-cropped.jpg"
          alt="Azim Ahmed"
        />
      </Col>
    </Row>
  );
};

export default PersonalInfo;
